<template>
<div class="header-none">
  <div class="wrapper" >
    <div class="parent top-p">
      <span class="success-span-register" v-if="this.$store.state.user_registered">Registered Successfully, Please check your email to validate your account.</span>

      <img src="/static/images/acc/Homepage.jpg" alt="nobanner" class="width100">
      <div class="advice-content text-centr">
        <h1 class="heading-style">
          Did you know that you don't have to register for copyright?
        </h1>
        <span class="sub-content bold-f-w">
          We provide accessible and affordable legal advice and education on copyright law for Australian content creators and consumers.
        </span>
        <acc-search></acc-search>
      </div>
    </div>

      <div class="latest-news m-auto">
        <div class="container news-heading-1 m-auto text-centr margin-top-20">
        </div>
        <div class="inner-content grid-d">
        </div>
      </div>

      <div class="latest-blog" v-if="blog_posts.length > 0">
        <div class="container">
        <carousel :items="3" :responsive="{1000:{items:3}}" :loop="true" :dots="false" :navText="['❮', '❯']"  :margin="20">
          <div v-for="blog_post in blog_posts">
            <a class="home-acc-feature"  v-bind:href="blog_post.url">
              <img  v-bind:src="blog_post.hero_image">
              <div class="inner-col">
                  <h3 class="acc-home-h3">{{blog_post.title}}</h3>
                  <p>
                    {{blog_post.summary}}
                  </p>
                  <div style="color:#f6793c;" class="col-button centr-align d-flex">LEARN
                    <img src="/static/css/images/acc/right-orange.png" class="orange-arrow">
                  </div>
              </div>
            </a>
          </div>
        </carousel>
        </div>
      </div>
    </div>
    <div class="flash-banner">

    <!-- Reference link -->
    <!-- https://www.w3schools.com/howto/howto_js_slideshow.asp -->
      <!-- <img src="/static/css/images/acc/Flash Banner.png" class="width100">  -->
    <p class="slider-heading">Frequently asked questions</p>
    <div class="slideshow-container">
        <!-- Full-width images with number and caption text -->
        <a href="/browse/book/ACC-An-Introduction-to-Copyright-in-Australia-INFO010">
          <div class="mySlides fade">
            <img src="/static/images/acc/FAQ/FAQ Banners1.jpg" style="width:90%;margin-left:5%;">
          </div>
      </a>
      <a href="/browse/book/ACC-Duration-of-Copyright-INFO023">
        <div class="mySlides fade">
          <img src="/static/images/acc/FAQ/FAQ Banners2.jpg" style="width:90%;margin-left:5%;">
        </div>
      </a>

     <a href="/browse/book/ACC-Protecting-Your-Copyright-INFO084">
      <div class="mySlides fade">
        <img src="/static/images/acc/FAQ/FAQ Banners3.jpg" style="width:90%;margin-left:5%;">
      </div>
     </a>

      <a href="/browse/book/ACC-Permission:-Do-I-Need-It-INFO103">
        <div class="mySlides fade">
          <img src="/static/images/acc/FAQ/FAQ Banners4.jpg" style="width:90%;margin-left:5%;">
        </div>
      </a>

       <a href="/browse/book/ACC-Permission:-Do-I-Need-It-INFO103">
        <div class="mySlides fade">
          <img src="/static/images/acc/FAQ/FAQ Banners5.jpg" style="width:90%;margin-left:5%;">
        </div>
      </a>

       <a href="/browse/book/ACC-Fair-Dealing:-What-Can-I-Use-Without-Permission-INFO079">
        <div class="mySlides fade">
          <img src="/static/images/acc/FAQ/FAQ Banners6.jpg" style="width:90%;margin-left:5%;">
        </div>
      </a>

       <a href="/browse/book/ACC-Permission:-Do-I-Need-It-INFO103">
        <div class="mySlides fade">
          <img src="/static/images/acc/FAQ/FAQ Banners7.jpg" style="width:90%;margin-left:5%;">
        </div>
      </a>

       <a href="/browse/book/ACC-Moral-Rights-INFO043">
        <div class="mySlides fade">
          <img src="/static/images/acc/FAQ/FAQ Banners8.jpg" style="width:90%;margin-left:5%;">
        </div>
      </a>

       <a href="/search?page=1&keyword=INFO056" onclick="location.href='/search?page=1&keyword=INFO094';" target="_blank">
        <div class="mySlides fade">
          <img src="/static/images/acc/FAQ/FAQ Banners9.jpg" style="width:90%;margin-left:5%;">
        </div>
      </a>
       <a href="/search?page=1&keyword=INFO036" onclick="location.href='/search?page=1&keyword=INFO103';" target="_blank">
        <div class="mySlides fade">
          <img src="/static/images/acc/FAQ/FAQ Banners10.jpg" style="width:90%;margin-left:5%;">
        </div>
      </a>
      <!-- Next and previous buttons -->
      <!-- Next and previous buttons -->
      <a class="prev" v-on:click="plusSlides(-1)">&#10094;</a>
      <a class="next" v-on:click="plusSlides(1)">&#10095;</a>
    </div>
    <div class="dottedouter" style="text-align:center">
      <span class="dot" v-on:click="currentSlide(1)"></span>
      <span class="dot" v-on:click="currentSlide(2)"></span>
      <span class="dot" v-on:click="currentSlide(3)"></span>
      <span class="dot" v-on:click="currentSlide(4)"></span>
      <span class="dot" v-on:click="currentSlide(5)"></span>
      <span class="dot" v-on:click="currentSlide(6)"></span>
      <span class="dot" v-on:click="currentSlide(7)"></span>
      <span class="dot" v-on:click="currentSlide(8)"></span>
      <span class="dot" v-on:click="currentSlide(9)"></span>
      <span class="dot" v-on:click="currentSlide(10)"></span>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import AccSearch from '../../views/AccSearch';
import "swiper/dist/css/swiper.css";
import homeMixin from "../../mixins/Home";
import layoutMixin from "../../mixins/Layout";
import carousel from 'vue-owl-carousel'                        

export default {
  name: "home",
  components:{
      AccSearch,
      carousel,
  },
  mixins: [homeMixin,layoutMixin],
  methods: {
    plusSlides: function (n) {
      this.showSlides(this.slideIndex += n);
    },
    currentSlide: function (n){
      this.showSlides(this.slideIndex = n);
    },
    showSlides(n){
      let i;
      let slides = document.getElementsByClassName("mySlides");
      let dots = document.getElementsByClassName("dot");
      if (n > slides.length) {this.slideIndex = 1}
      if (n < 1) {this.slideIndex = slides.length}
      for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
      }
      slides[this.slideIndex-1].style.display = "block";
      dots[this.slideIndex-1].className += " active";
    },
  },
 mounted() {
    let current_url= window.location.href;
    this.showSlides(this.slideIndex)
    if(this.$store.state.user_registered) {
      setTimeout(function() {
          $('.success-span-register').fadeOut('fast');
      }, 5000)
    }
  },
  data(){
    return {
    slideIndex:1,
      blog_posts_limit: 6,
    }
  }
};
</script>
<style>
  .dot {
    cursor: pointer;
    height: 16px;
    width: 16px;
    margin: 0 4px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    -webkit-transition: background-color 0.6s ease;
    transition: background-color 0.6s ease;
  }

  .active, .dot:hover {
    background-color: #ef7738;
  }

  .slideshow-container {
    position: relative;
  }

	.slideshow-container .prev {
		position: absolute;
		left: 2%;
		width: 40px;
		height: 40px;
		top: 0;
		bottom: 0;
		margin: auto;
		display: flex;
		font-size: 20px;
		align-items: center;
		justify-content: center;
		cursor:pointer;
	}
	.slideshow-container .next {
		position: absolute;
		right: 2%;
		width: 40px;
		height: 40px;
		top: 0;
		bottom: 0;
		margin: auto;
		display: flex;
		font-size: 20px;
		align-items: center;
		justify-content: center;
		cursor:pointer;
	}
	.dottedouter{
		text-align: center;
		position: relative;
		width: 100%;
		bottom: 50px;
		z-index: 9;
	}
	.slider-heading {
		text-align: center;
		font-size: 32px;
		color: #41525c;
		font-weight: 600;
	}
  a.home-acc-feature {
    display: block;
    color: #000000;
    background: #fff;
}

a.home-acc-feature .orange-arrow {
    width: 16px !important;
}
.owl-theme .owl-nav {
    margin-top: 180px;
    text-align: center;
    -webkit-tap-highlight-color: transparent;
    position: absolute;
    width: 100%;
    height: 40px;
    top: 32%;
    bottom: 0;
    margin: auto;
    background:transparent !important;
}
.latest-blog .owl-prev {
    position: absolute;
    left: -80px;
    width: 40px !important;
    height: 40px !important;
    padding:5px !important;
    top: 0%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    border-radius: 50% !important;
    font-size: 20px !important;
    color: #ed773a !important;
    line-height: 23px;
}

.latest-blog .owl-next {
    position: absolute;
    right: -80px;
    width: 40px !important;
    height: 40px !important;
    padding:5px !important;
    top: 0%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    border-radius: 50% !important;
    font-size: 20px !important;
    color: #ed773a !important;
    line-height: 23px;
}


a.home-acc-feature .inner-col {
    margin-top: 15px;
}
.latest-blog {
    position: relative;
}

.owl-theme .owl-nav [class*='owl-']:hover {
  background-color: transparent !important;
}
.owl-theme .owl-nav [class*='owl-'] {
    background: transparent !important;
}
	@media screen and  (max-width: 575.98px) {
	  .advice-content h1{display: none;}
	  .search {padding: 7px; width: calc(100% - 8%);}
	  .heading-style{display: none;}
	  .mobileHide{display: none;}
	  .news_txt{font-size:18px;}
	  .subscribe-mailchimp{width:90%; right:0;}
	  .proopc-finalpage input[type=text], input[type=password], input[type=email], textarea, .selecter .selecter-selected {width: 100%;}
	  .subscribe-mailchimp{margin-top:20px;}
	  .latest-news .inner-content {display: flex;flex-direction: column;}
	  .latest-news .prv-img {display: none;}
	  .flash-banner {padding: 20px 0px;}
	  .search .search-button{margin-right:15px;background:transparent;}
	  .search input[type=text] {border: none; width: 80% !important; margin-left: 18px;}
	  .logo img{width:90px;}
	  .l-footer{background-size: cover;}
	  .footer-content a{padding:20px 13px;}
	  .dottedouter {bottom: -14px;}
	  .advice-content{background:transparent; padding: 0;}
	}
</style>